firebird.factory('videoLayoutZoomService', [
    '$timeout',
    'logService',
    function ($timeout, logService) {
        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoLayoutZoomService');
        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            self.zoomVideoElement = zoomVideoElement;
            self.zoomResizeVideoElement = zoomResizeVideoElement;
            self.restoreVideoElement = restoreVideoElement;
            self.reapplyZoomAfter = reapplyZoomAfter;
        }

        // given a rectangle position {x, y, w, h}, convert to relative position within
        // the video. adjust for object-fit style and actual video sizes if possible.

        function getPositionAbsoluteToRelative(div, video, position) {
            var W = div.offsetWidth,
                H = div.offsetHeight;
            var p = { W: W, H: H, x: position.x, y: position.y, w: position.w, h: position.h };

            if (video && video.videoWidth && video.videoHeight) {
                p.video = true;

                var style = getComputedStyle(video);
                var w = video.videoWidth,
                    h = video.videoHeight;
                var r = w / h,
                    R = W / H;
                p.W = w;
                p.H = h;
                if ((style.objectFit == 'cover' && r >= R) || (style.objectFit == 'contain' && r < R)) {
                    h = H;
                    w = H * r;
                    p.x = ((position.x + (w / 2 - W / 2)) / w) * p.W;
                    p.y = (position.y / h) * p.H;
                } else if ((style.objectFit == 'cover' && r < R) || (style.objectFit == 'contain' && r >= R)) {
                    h = W / r;
                    w = W;
                    p.y = ((position.y + (h / 2 - H / 2)) / h) * p.H;
                    p.x = (position.x / w) * p.W;
                }
                p.w = (position.w / w) * p.W;
                p.h = (position.h / h) * p.H;
                if (p.x < 0) {
                    p.w = p.w + p.x;
                    p.x = 0;
                }
                if (p.y < 0) {
                    p.h = p.h + p.y;
                    p.y = 0;
                }
                if (p.x + p.w > p.W) {
                    p.w = p.W - p.x;
                }
                if (p.y + p.h > p.H) {
                    p.h = p.H - p.y;
                }
            }

            return p;
        }

        // resize the zoomed portion of the video element based on existing zoom data.
        function zoomResizeVideoElement(div) {
            var video = div.querySelector('video');
            var p = div.zoomData;

            var W = div.offsetWidth,
                H = div.offsetHeight;
            var ratio_x = W / p.w,
                ratio_y = H / p.h;
            var ratio = Math.min(ratio_x, ratio_y);

            var w = Math.round(p.W * ratio);
            var h = Math.round(p.H * ratio);
            var x, y;
            var px = p.x,
                py = p.y,
                pw = p.w,
                ph = p.h;

            if (w < W || h < H) {
                var ratio_w = W / w,
                    ratio_h = H / h;
                var ratio1 = Math.max(ratio_w, ratio_h);
                ratio = ratio * ratio1;
                w = Math.round(p.W * ratio);
                h = Math.round(p.H * ratio);
                if (pw * ratio > W) {
                    px = px + pw / 2 - W / (2 * ratio);
                    pw = W / ratio;
                }
                if (ph * ratio > H) {
                    py = py + ph / 2 - H / (2 * ratio);
                    ph = H / ratio;
                }
            }

            if (ratio_x <= ratio_y) {
                x = px * -ratio;
                y = H / 2 - ratio * (py + ph / 2);
                if (y > 0) {
                    y = 0;
                }
                if (H - y > h) {
                    y = H - h;
                }
            } else {
                x = W / 2 - ratio * (px + pw / 2);
                y = py * -ratio;
                if (x > 0) {
                    x = 0;
                }
                if (W - x > w) {
                    x = W - w;
                }
            }

            x = Math.round(x);
            y = Math.round(y);

            var style = 'left: ' + x + 'px; top: ' + y + 'px; width: ' + w + 'px; height: ' + h + 'px;';

            video.setAttribute('style', style);
        }

        // zoom a portion of the video element so that it expands to fill
        // the full size in contain object fit style. If position is
        // specified it has the rectangle x,y,w,h.
        function zoomVideoElement(div, position, noanimate) {
            var video = div.querySelector('video');
            if (position.w >= 20 && position.h >= 20) {
                div.zoomData = getPositionAbsoluteToRelative(div, video, position);

                var ratio_x = div.offsetWidth / position.w,
                    ratio_y = div.offsetHeight / position.h;
                var ratio = Math.min(ratio_x, ratio_y);

                if (ratio > 1) {
                    var w = Math.round(div.offsetWidth * ratio);
                    var h = Math.round(div.offsetHeight * ratio);
                    var x, y;
                    var r = div.offsetWidth / div.offsetHeight;

                    if (ratio_x <= ratio_y) {
                        x = position.x * -ratio;
                        y = (position.y - position.w / (r * 2) + position.h / 2) * -ratio;
                        if (y > 0) {
                            y = 0;
                        }
                        if (y < div.offsetHeight - h) {
                            y = div.offsetHeight - h;
                        }
                    } else {
                        x = (position.x - (position.h * r) / 2 + position.w / 2) * -ratio;
                        y = position.y * -ratio;
                        if (x > 0) {
                            x = 0;
                        }
                        if (x < div.offsetWidth - w) {
                            x = div.offsetWidth - w;
                        }
                    }
                    x = Math.round(x);
                    y = Math.round(y);

                    var style0 =
                        'left: 0px; top: 0px; width: ' + div.offsetWidth + 'px; height: ' + div.offsetHeight + 'px;';

                    video.setAttribute('style', style0);

                    var style =
                        (!noanimate ? 'transition: all .3s; ' : '') +
                        'left: ' +
                        x +
                        'px; top: ' +
                        y +
                        'px; width: ' +
                        w +
                        'px; height: ' +
                        h +
                        'px;';

                    //logger.log('videoroomCtrl zoom video element, ratio=' + ratio);
                    $timeout(function () {
                        if (video.getAttribute('style') != style) {
                            video.setAttribute('style', style);
                        }
                    }, 0);
                } else {
                    logger.log('videoroomCtrl cannot zoom out, ratio=' + ratio);
                }
            }
        }

        // restore zoom level of video element.
        function restoreVideoElement(div) {
            var video = div.querySelector('video');

            delete div.zoomData;
            var style1 =
                'transition: all .3s; left: 0px; top: 0px; width: ' +
                div.offsetWidth +
                'px; height: ' +
                div.offsetHeight +
                'px;';

            logger.log('videoroomCtrl restore video element');
            video.setAttribute('style', style1);

            $timeout(function () {
                video.removeAttribute('style');
            }, 400);
        }

        // reapply the zoom data after a timeout, to accumulate multiple calls during resize.
        function reapplyZoomAfter(div) {
            if (div.zoomTimer) {
                $timeout.cancel(div.zoomTimer);
                div.zoomTimer = null;
            }
            div.zoomTimer = $timeout(function () {
                div.zoomTimer = null;
                if (div.zoomData) {
                    self.zoomResizeVideoElement(div);
                }
            }, 300);
        }
    }
]);
